import { gql as apolloGql } from '@apollo/client'

export const ADVISOR_ENGAGEMENT_CHAT_THREAD_FRAGMENT = apolloGql`
  fragment AdvisorEngagementChatThreadFragment on ScoAdvisorEngagement {
    chatThread {
      id
      threadId
      currentUserUnreadCommentsCount
      lastActiveAt
    }
  }
`
